import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import ViewSettingsPanelContentQuery from '@atlassian/jira-relay/src/__generated__/ViewSettingsPanelContentQuery.graphql';
import { getBoardQueryParams } from '@atlassian/jira-business-board-query-params/src/query-params.tsx';

export const viewSettingsPanelEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-business-board-view-settings-panel-entrypoint" */ './ViewSettingsPanelContent.tsx'
			),
	),
	getPreloadProps: ({ viewId }: { viewId: string }) => ({
		queries: {
			mainQuery: {
				parameters: ViewSettingsPanelContentQuery,
				variables: {
					viewInput: {
						jiraBoardViewQueryInput: {
							viewId,
						},
						settings: getBoardQueryParams(),
					},
				},
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
			},
		},
	}),
});
